import { createTheme } from "@material-ui/core/styles";

const primaryColor = "#00afc6";
const primaryAlphaColor = "rgba(0, 175, 198, .15)";
const primaryAlphaHoverColor = "rgba(0, 175, 198, .3)";
const errorAlphaColor = "rgba(245, 0, 87, 0.15)";

// Custom Mui Theme for our project
const theme = createTheme({
  palette: {
    primary: {
      main: primaryColor, // "#2c3ff3"
      opacity: primaryAlphaColor,
      opacityHover: primaryAlphaHoverColor,
      contrastText: "#fff"
    },
    error: {
      main: "#f44336",
      opacity: errorAlphaColor
    },
    text: {
      main: "#333",
      secondary: "#91919F"
    }
  },
  // shape: {
  //   borderRadius: 13
  // },
  overrides: {
    MuiAppBar: {
      root: {
        boxSizing: "border-box"
      }
    },
    MuiMenu: {
      paper: {
        maxHeight: "100%",
        padding: "0 !important",

        "&.MuiPopover-paper": {
          maxHeight: 700
        }
      }
    },
    MuiInputBase: {
      input: {
        padding: "7px 0 8px"
      }
    },
    MuiOutlinedInput: {
      inputMarginDense: {
        paddingTop: 9.5,
        paddingBottom: 9.5
      }
    },
    MuiButton: {
      root: {
        zIndex: 9,
        padding: "7px 16px",
        borderRadius: 6,
        textTransform: "none"
      },
      label: {
        whiteSpace: "nowrap"
      },
      outlined: {
        padding: "6px 15px"
      },
      text: {
        padding: "9px 16px"
      },
      contained: {
        boxShadow: "none"
      }
      // containedPrimary: {
      //   background:
      //     "linear-gradient(45deg, #04b7d2 30%, #0ebed8 90%) !important",
      //   color: "#fff !important",
      //   "&&:hover": {
      //     background:
      //       "linear-gradient(45deg, #02abc3 30%, #07b4c7 90%) !important"
      //   }
      // },
      // containedSecondary: {
      //   background: "#cdcdcd !important",
      //   boxShadow:
      //     "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)",
      //   color: "#fff !important",
      //   "&&:hover": {
      //     background: "#bcbcbc !important"
      //   }
      // },
      // outlined: {
      //   border: "1px solid #04b7d2",
      //   boxShadow: "none"
      // },
      // textPrimary: {
      //   width: 0,
      //   padding: 0,
      //   marginBottom: 0,
      //   height: "auto",
      //   minWidth: 40,
      //   boxShadow: "none",
      //   background: "none",
      //   "&&:hover": {
      //     background: "none"
      //   }
      // },
      // outlinedPrimary: {
      //   backgroundColor: "#0ebdd742",
      //   "&&:hover": {
      //     backgroundColor: "#0ebdd742"
      //   }
      // },
      // outlinedSecondary: {
      //   backgroundColor: "#fff",
      //   color: "#04b7d2",
      //   border: "1px solid #0ebdd742",
      //   "&&:hover": {
      //     border: "1px solid #0ebdd7"
      //   }
      // }
    },
    // MuiFab: {
    //   root: {
    //     borderRadius: 24,
    //     border: 0,
    //     height: 48,
    //     marginBottom: 48,
    //     boxShadow: "none",
    //     background: "linear-gradient(45deg, #04b7d2 30%, #0ebed8 90%)",
    //     color: "white",
    //     zIndex: 9,
    //     "&&:hover": {
    //       background: "linear-gradient(45deg, #00b4ce 30%, #08bcd0 90%)"
    //     }
    //   }
    // },
    MuiIconButton: {
      root: {
        alignSelf: "center"
      }
    },
    MuiPaper: {
      rounded: {
        padding: 24,
        borderRadius: 20
        // marginBottom: 24,
      },
      elevation4: {
        boxShadow: "0 2px 10px rgba(51,51,51,0.1)"
      },
      elevation8: {
        boxShadow: "0 2px 9px rgba(0,0,0,0.1)",
        border: "1px solid #E6E6E6",
        borderRadius: 8
      },
      elevation10: {
        boxShadow: "0 2px 10px rgba(51, 51, 59, 0.1)"
      }
    },
    MuiDrawer: {
      paperAnchorDockedLeft: {
        borderRight: "none"
      }
    },
    MuiSelect: {
      icon: {
        top: "calc(50% - 11px)",
        right: 3
      }
    },
    // MuiPopover: {
    //   paper: {
    //     padding: 0
    //   }
    // },
    MuiDialog: {
      paper: {
        borderRadius: 6
      }
    },
    MuiPickersPopper: {
      paper: {
        padding: 0
      }
    },
    MuiChip: {
      colorPrimary: {
        backgroundColor: primaryAlphaColor,
        color: primaryColor
      },
      sizeSmall: {
        height: "auto"
      }
    },
    MuiListItemIcon: {
      root: {
        minWidth: 30
      }
    },
    MuiTooltip: {
      tooltip: {
        fontSize: 11
      }
    }
    // MuiTableBody: {
    //   root: {
    //     "& tr:nth-child(2n-1)": {
    //       background: "#f6f6f6"
    //     }
    //   }
    // },
    // MuiSelect: {
    //   filled: {
    //     "&&:hover": {
    //       border: "none"
    //     },
    //     "&&:focus": {
    //       border: "none"
    //     }
    //   },
    //   select: {
    //     "&&:hover": {
    //       border: "none"
    //     },
    //     "&&:focus": {
    //       background: "#fff",
    //       borderRadius: 24,
    //       border: "none"
    //     }
    //   },
    //   selectMenu: {
    //     padding: "10px 50px 10px 20px",
    //     borderRadius: 24,
    //     background: "#fff"
    //   },
    //   outlined: {
    //     border: "1px solid #04b7d2",
    //     "&&:hover": {
    //       border: "1px solid #00b4ce"
    //     },
    //     "&&:focus": {
    //       border: "1px solid #00b4ce"
    //     }
    //   }
    // },
    // MuiInput: {
    //   root: {
    //     overflow: "hidden"
    //   }
    // },
    // MuiOutlinedInput: {
    //   root: {
    //     borderRadius: 24,
    //     border: 0
    //   },
    //   notchedOutline: {
    //     border: 0
    //   }
    // },
    // MuiStepIcon: {
    //   text: {
    //     fill: "#fff"
    //   }
    // }
  }
});

export default theme;
